import RegisterPageWrapper from '../Register/RegisterPageWrapper';
const UnbrandedRegistration = ({
	test = false,
	isCampaign = false,
	isStandaloneCampaign = false,
}) => {
	return (
		<RegisterPageWrapper
			test={test}
			isCampaign={isCampaign}
			isStandaloneCampaign={isStandaloneCampaign}
		/>
	);
};

export default UnbrandedRegistration;
